export default __webpack_public_path__ + "static/media/level-high.7280e207.svg";